// Formatting helpers for source cards. Locale follows the dashboard UI.

const intlLocale = locale => (locale || 'ru').replace('_', '-');

export const formatCount = (value, locale) => {
  if (value === null || value === undefined || value === '') return '';
  const number = Number(value);
  if (Number.isNaN(number)) return String(value);
  return new Intl.NumberFormat(intlLocale(locale), {
    notation: number >= 10000 ? 'compact' : 'standard',
    maximumFractionDigits: 1,
  }).format(number);
};

export const formatPrice = (value, locale) => {
  if (value === null || value === undefined || value === '') return '';
  return new Intl.NumberFormat(intlLocale(locale), {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
  }).format(Number(value));
};

export const formatDateTime = (value, locale) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat(intlLocale(locale), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const formatDate = (value, locale) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat(intlLocale(locale), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(date);
};

// Remaining time split into days/hours/minutes; null when already expired.
export const remainingParts = (until, now) => {
  if (!until) return null;
  const diff = new Date(until).getTime() - now;
  if (Number.isNaN(diff) || diff <= 0) return null;
  const minutes = Math.floor(diff / 60000);
  return {
    days: Math.floor(minutes / 1440),
    hours: Math.floor((minutes % 1440) / 60),
    minutes: minutes % 60,
    totalHours: diff / 3600000,
  };
};

export const hasValue = value =>
  value !== null && value !== undefined && value !== '';

const OUTGOING = 1;
const INCOMING = 0;

export const getConversationSource = chat =>
  chat?.additional_attributes?.source || null;

// Latest public reply published by the brand (outgoing, not a private note).
export const findPublishedReply = (messages = []) =>
  [...messages]
    .reverse()
    .find(
      message =>
        message.message_type === OUTGOING && !message.private && message.content
    ) || null;

export const findLastIncomingAt = (messages = []) =>
  [...messages].reverse().find(message => message.message_type === INCOMING)
    ?.created_at || 0;

// `single` sources accept one public reply; once it exists the reply editor
// only allows private notes.
export const isPublicReplyLocked = chat =>
  getConversationSource(chat)?.reply_mode === 'single' &&
  !!findPublishedReply(chat?.messages);
